window.$ = window.jQuery = require("jquery");

// Lazy sweetalert2: tira ~40K do bundle inicial (menos TBT). Carrega sob 1º uso.
// Mantém a API global usada no projeto (Swal.fire + Swal.DismissReason).
let _swalPromise;
function loadSwal() {
    return (
        _swalPromise ||
        (_swalPromise = import(
            /* webpackChunkName: "sweetalert2" */ "sweetalert2"
        ).then((m) => m.default))
    );
}
window.Swal = {
    fire: (...args) => loadSwal().then((s) => s.fire(...args)),
    DismissReason: {
        cancel: "cancel",
        backdrop: "backdrop",
        close: "close",
        esc: "esc",
        timer: "timer",
    },
};

const WhatsAppButtons = document.getElementsByClassName("contatos");

function handleWhatsAppButtonClick() {
    const facebook_person = $("#fbp").val();
    const facebook_click = $("#fbc").val();

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    $.ajax({
        url: "/fb-whatsapp",
        type: "post",
        data: {
            facebook_person:
                facebook_person != "undefined" ? facebook_person : null,
            facebook_click:
                facebook_click != "undefined" ? facebook_click : null,
        },
        success: function (response) {},
        error: function (error) {},
        complete: () => {
            $(".loading").removeClass("active");
        },
    });
}

for (var i = 0; i < WhatsAppButtons.length; i++) {
    WhatsAppButtons[i].addEventListener("click", handleWhatsAppButtonClick);
}

const button = document.getElementById("whats_balao");
button?.addEventListener("click", handleWhatsAppButtonClick);

$("#valide-terms").on("click", function () {
    const facebook_person = $("#fbp").val();
    const facebook_click = $("#fbc").val();

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    $.ajax({
        url: "/initiate-checkout",
        type: "post",
        data: {
            facebook_person:
                facebook_person != "undefined" ? facebook_person : null,
            facebook_click:
                facebook_click != "undefined" ? facebook_click : null,
        },
        success: function (response) {},
        error: function (error) {},
        complete: () => {
            $(".loading").removeClass("active");
        },
    });
});

// Lazy crypto-js/sha256: só carrega ao interagir com os campos do carrinho.
let _sha256;
$(
    "#cart-nome,#cart-phone,#cart-email,#cart-cpf,#cart-cep,#cart-adress,#cart-number,#cart-neighborhood,#cart-city"
).on("blur", async function () {
    const fieldName = $(this).attr("name");

    let value = null;
    if (fieldName != "email") {
        value = $(this)
            .val()
            .replace(/[().-\s]/g, "");
    } else {
        value = $(this).val();
    }

    if (fieldName == "cellphone") {
        value = `+55${value}`;
    }

    if (!_sha256) {
        _sha256 = (
            await import(/* webpackChunkName: "sha256" */ "crypto-js/sha256")
        ).default;
    }
    $(`#${fieldName}-sha-256`).val(_sha256(value).toString());
});

require("./lp/app");
require("./reveal");
require("./reading-progress");
require("./header-scroll");
require("./typewriter");
require("./recaptcha-lazy");
require("./fb-pixel-consent");
